import React, { useCallback, useEffect, useState } from 'react';
import getSlideIndex from '../hooks/getSlideIndex';
import useScrollSnapSliderContext from '../hooks/useScrollSnapSliderContext';

export default function SlideIndex(): JSX.Element {
    const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
    const slider = useScrollSnapSliderContext();

    const setSelectedIndex = useCallback(
        (event) => {
            const slideIndex = getSlideIndex({ event, slider });

            setCurrentSlideIndex(slideIndex);
        },
        [slider]
    );

    useEffect(() => {
        slider?.addEventListener('slide-pass', setSelectedIndex);

        return () => {
            slider?.removeEventListener('slide-pass', setSelectedIndex);
        };
    }, [slider, setSelectedIndex]);

    return <>{currentSlideIndex + 1}</>;
}
